<template>
	<div class="page-nav">
		<nav class="page-nav__list">
			<a v-if="['administrator', 'manager', 'supplier'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/') }" href="/personal/">Тендеры</a>
			<a v-if="['administrator', 'category_admin', 'category_manager', 'manager'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/schedules/') }" href="/personal/schedules/">График тендеров</a>
			<a v-if="['administrator', 'manager'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/shop-groups/') }" href="/personal/shop-groups/">Группы магазинов</a>
			<a
				v-if="['administrator', 'category_admin', 'category_manager', 'manager'].includes(getUserRole)"
				class="page-nav__link"
				:class="{ active: ['category_admin', 'category_manager'].includes(getUserRole) ? isActive('/personal/') || isActive('/personal/suppliers/') : isActive('/personal/suppliers/') }" href="/personal/suppliers/">Поставщики</a>
			<a v-if="['administrator', 'category_admin', 'category_manager', 'manager'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/stats/') }" href="/personal/stats/">Статистика</a>
			<a v-if="['manager'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/notifications/') }" href="/personal/notifications/" :[attr]="count">Уведомления</a>
			<a v-if="['administrator'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/category-admins/') }" href="/personal/category-admins/">Управляющие категориями</a>
			<a v-if="['administrator', 'category_admin'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/category-managers/') }" href="/personal/category-managers/">Категорийные менеджеры</a>
			<a v-if="['administrator', 'category_admin', 'category_manager'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/managers/') }" href="/personal/managers/">Менеджеры</a>
			<a v-if="['administrator', 'category_admin', 'category_manager', 'manager'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/blacklist/') }" href="/personal/blacklist/">Черный список</a>
			<a v-if="['supplier'].includes(getUserRole)" class="page-nav__link" :class="{ active: isActive('/personal/supplier-card/') }" href="/personal/supplier-card/">Карточка поставщика</a>
		</nav>
	</div>

	<InfoBanner/>
	<MyManager v-if="checkUserRole('supplier')" type="managers"/>
	<MyManager v-if="checkUserRole('manager') || checkUserRole('category_manager')" type="category-admins"/>
	<MyManager v-if="checkUserRole('manager')" type="category-managers"/>
</template>

<script>
import { mapGetters } from "vuex";
import MyManager from "@/components/blocks/MyManager.vue";
import InfoBanner from "@/components/blocks/InfoBanner.vue";

export default {
	name: "PageNav",
	components: {InfoBanner, MyManager},
	data() {
		return {
			attr: 'data-count',
			count: null
		}
	},
	mounted() {
		this.count = this.getUserNotice ? `+${this.getUserNotice}` : null
	},
	computed: {
		isActive() {
			return (href) => {
				return window.location.pathname === href
			}
		},
		...mapGetters({
			checkUserRole: 'user/checkUserRole',
			getUserNotice: 'user/getUserNotice',
			getUserRole: 'user/getUserRole',
		})
	},
	
}
</script>


